import rollbar from '~/vendor/rollbar';
import {createAction} from 'redux-actions';
import remoteServices from '~/constants/RemoteServices';
import AccountTypes from '~/constants/types/AccountTypes';
import {buildUrl} from '~/utils/url';
import {deserializeSavedDesigns} from '~/data/deserializers/account';
import {selectCartEmail} from '~/api/designs/cartApi';
import {isRetrieveDesignsActive} from '../selectors/ConfigSelectors';

export const setPreferSingles = createAction(AccountTypes.SET_PREFER_SINGLES);
const fetchSavedDesignsSuccess = createAction(
  AccountTypes.FETCH_SAVED_DESIGNS_SUCCESS
);

export const updateInternalUser = createAction(
  AccountTypes.UPDATE_INTERNAL_USER
);

export function setSelectedSavedDesignIndex(index) {
  return dispatch => {
    dispatch({
      type: AccountTypes.SELECT_SAVED_DESIGN_INDEX,
      payload: {savedDesignIndex: index}
    });
  };
}

export function location() {
  return dispatch => {
    dispatch({type: AccountTypes.LOCATION});

    return window
      .fetch(`${remoteServices.accounts}/ip-check`)
      .then(response => {
        if (!response.ok) {
          return dispatch(locationFailed(response));
        }
        return response.json().then(data => dispatch(locationLoaded(data)));
      })
      .catch(error => dispatch(locationFailed(error)));
  };
}

export function updateSdfu({id, optIn}) {
  return dispatch => {
    return window
      .fetch(`${remoteServices.accounts}/account/sdfu`, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id,
          sdfu: optIn ? 1 : 0
        })
      })
      .then(result =>
        dispatch({type: AccountTypes.UPDATE_SDFU, payload: {status: result}})
      )
      .catch(error => {
        rollbar.warn('External Service Failure: SDFU', error);
        dispatch({type: AccountTypes.UPDATE_SDFU, payload: {status: error}});
      });
  };
}

export function fetchSavedDesigns({
  page,
  perPage = 6,
  email,
  imageSize = 'front_small_extended'
}) {
  return async (dispatch, getState) => {
    try {
      dispatch({type: AccountTypes.FETCH_SAVED_DESIGNS_START});
      const state = getState();
      const shouldUseEmailFromCart = !isRetrieveDesignsActive(state);
      const resolvedEmail = shouldUseEmailFromCart
        ? selectCartEmail(state)
        : email;
      const queryParams = {
        api_version: 2,
        page,
        per_page: perPage,
        email: resolvedEmail
      };
      const path = `${remoteServices.designs}/api/designs.json`;
      const url = buildUrl(path, queryParams);
      const response = await window.fetch(url, {method: 'get'});
      if (!response.ok) {
        throw response;
      } else {
        const results = await response.json();
        const savedDesigns = deserializeSavedDesigns(results, imageSize);
        return dispatch(
          fetchSavedDesignsSuccess({
            designs: savedDesigns.designs,
            hasMoreSavedDesigns: results.page < results.total_pages,
            page
          })
        );
      }
    } catch (error) {
      rollbar.warn('Fetch Saved Designs Failure', error);
      dispatch({type: AccountTypes.FETCH_SAVED_DESIGNS_FAILED, payload: error});
      return;
    }
  };
}

function locationLoaded(data) {
  return {
    type: AccountTypes.LOCATION_LOADED,
    payload: data.country || null
  };
}

function locationFailed(error) {
  rollbar.warn('External Service Failure: Location', error);
  return {
    type: AccountTypes.LOCATION_FAILED,
    payload: error,
    error: true
  };
}
